import { AppModal, AppModalSimple } from "Types/app"

// 应用初始带的modal
export const InitialModal: AppModal = {
    show: false,
    type: "default",
    title: "",
    onConfirm: () => {},
    onCancel: () => {},
}

export const InitialModalSimple: AppModalSimple = {
    show: false,
    title: "",
}
